// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H2Kh","left":"styles_left__1Ihu0","desktopActions":"styles_desktopActions__3fsuW","title":"styles_title__3RrvK"};